import { createSelector } from 'reselect'
import { selectCurrentContact } from 'ducks/crm/contacts/selectors/current'
import { emptyObj } from 'util/objects'
import { isEndUser } from '../utils/users'
import { selectMemberUserIdFromProps } from './users'

export function selectBase(state) {
  const { chat: { presence = emptyObj } = emptyObj } = state
  return presence
}

export const selectPresence = createSelector(selectBase, base => base.presence)

export const selectPresenceSettings = createSelector(
  selectBase,
  base => base.settings || emptyObj
)

export const selectAutoPresenceSetting = createSelector(
  selectPresenceSettings,
  settings => settings.autoPresence
)

export const selectAutoAwaySetting = createSelector(
  selectPresenceSettings,
  settings => settings.autoAway
)

export const selectAutoOfflineSetting = createSelector(
  selectPresenceSettings,
  settings => settings.autoOffline
)

export function selectByMatrixId(state) {
  return selectBase(state).byMatrixId
}

export const selectCurrentContactMatrixUserId = createSelector(
  selectCurrentContact,
  ({ handles = [] } = {}) => {
    const { value } =
      handles.find(h => h.type === 'custom' && isEndUser(h.value)) || {}
    // matrixId
    return value
  }
)

export const selectCurrentContactMatrixUserPresence = createSelector(
  selectByMatrixId,
  selectCurrentContactMatrixUserId,
  (matrixId, matrixUserId) => {
    return matrixId[matrixUserId] || 'unknown'
  }
)

export function selectIsMxClientLoading(state) {
  return selectPresence(state).isLoading
}

export function selectMxEventFromProps(_, props) {
  return props.mxEvent
}

export function makeSelectPresenceByMemberId() {
  return createSelector(
    selectByMatrixId,
    selectMemberUserIdFromProps,
    (byMatrixId, userId) => {
      return byMatrixId[userId] || 'offline'
    }
  )
}
